import React , {Component} from 'react';
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';
import Modal from 'react-modal';
import firebase from 'firebase';
import Alert from 'react-s-alert';

const database =firebase.database();

const customStyles = {
  content : {
    top                   : '50%',
    left                  : '50%',
    right                 : 'auto',
    bottom                : 'auto',
    transform             : 'translate(-50%, -50%)',
	width                 : '700px'
	
  }
};


class ModalCalificaciones extends Component{
	
	
	constructor(props){
		
		super(props)
		this.state={
			
			isActive:false,
			tipos_calificaciones:[],
			preguntas:[]
		
		}
		
		this.toggleModal=this.toggleModal.bind(this);
		this.tipos_calificaciones=database.ref().child('tipo_calificaciones');
		this.calificacionesRef=database.ref().child('Calificaciones');
		this.Calificaciones=database.ref().child('Calificaciones');
		this.makeItems=this.makeItems.bind(this);
		this.ingresarPregunta=this.ingresarPregunta.bind(this);
		this.renderTable=this.renderTable.bind(this);
		
		this.handleSubmit=this.handleSubmit.bind(this);
		this.handleClickEliminarPregunta=this.handleClickEliminarPregunta.bind(this);
	}
	
	
	componentDidMount(){
		
		this.tipos_calificaciones.on('value',this.gotDataTipos,this.errDataTipos)
		
		
	}
	
	
	componentWillMount(){
		
		
	}
	
	
	gotDataTipos=(data)=>{
		
		
		let tipos=[]
		let datatipos=data.val();
		
		
		if(datatipos!=null){
			
			
			let keys=Object.keys(datatipos);
			
			for(let i=0;i<keys.length;i++){
				
				let k=keys[i];
			
				if(datatipos[k].estado==="Activo"){
					
						
					tipos.push({
						
						key:k,
						nombre:datatipos[k].nombre
						
					})
					
				}
	
	
			}
			this.setState({tipos_calificaciones:tipos})
			
		}
		
	}
	errDataTipos=(err)=>{
		
		
		
	}
	
	makeItems(x){
		
		
		return <option key={x.key}>{x.nombre}</option>;
		
	}
	
	
	ingresarPregunta(){
		
		
		
			
				
		   this.Calificaciones.orderByChild('tipo').equalTo(this.tipo.value).on('value',(snapshot)=>{
			
				if(snapshot.exists()){
				
					Alert.warning('La encuesta para este tipo ya existe', {
						effect: 'genie',
						position: 'bottom-right',
						timeout:2000			
					});
				}
				else{
				
					if(this.pregunta.value!==""){
						
						
						
						let pre=this.state.preguntas.find(preguntas=>preguntas.pregunta===this.pregunta.value);
						
						
						
						
						if(pre===undefined && this.state.preguntas.length<5){
							
								this.state.preguntas.push({
									key:this.state.preguntas.length,
									estado:'activo',
									pregunta:this.pregunta.value,
									tipo:this.tipo.value
								})
								
								this.setState({
									
									preguntas:this.state.preguntas
								})
								
								this.pregunta.value="";
						}
						
						
						
						
					}
		
				}
			
			})

	}
		
	toggleModal(){
		
		this.setState({
			
			isActive:!this.state.isActive
			
		})
		
	}
	
	
	btnEliminarFormatter(cell,row){
				
		return <p className="glyphicon glyphicon-remove btn-eliminar" onClick={() => {this.handleClickEliminarPregunta(row)}} ></p>
	}
	
	renderTable(){
		
		if(this.state.preguntas.length===0){
			
				return(
					
					<center><p>Ingresa una nueva pregunta</p></center>
				);
		
	
		}
		else{
			
			return(
							
					<BootstrapTable data={ this.state.preguntas }
						 ref='table'			 
						 pagination={ false }
						 search={ false }
						 hover
						 >
						 <TableHeaderColumn dataField='key' isKey={true} dataSort={true} hidden >Nombre</TableHeaderColumn>
						 <TableHeaderColumn dataField='pregunta'  dataSort={true}  >Tipo</TableHeaderColumn>
						 <TableHeaderColumn dataField='edit' dataAlign='center' dataFormat={ this.btnEliminarFormatter.bind(this) }>Eliminar</TableHeaderColumn>					
					</BootstrapTable>	
			
			);
			
			
		}
		
		
	}
	
	
	
	handleClickEliminarPregunta(row){
		
		
		this.setState({
			
			preguntas:this.state.preguntas.filter(preguntas=>preguntas.key!==row.key)
				
		})
	
		
	}
	
	
	
	handleSubmit(){
		
		
		
		if(this.state.preguntas===0){
			
			Alert.warning('Debes agregar al menos una pregunta', {
				effect: 'genie',
				position: 'bottom-right',
				timeout:2000			
			});
					
			
		}
		else{

			for(let i=0;i<this.state.preguntas.length;i++){
				
				this.Calificaciones.push({
					
					estado:'activo',
					pregunta:this.state.preguntas[i].pregunta,
					tipo:this.tipo.value	
				})
				
				
				Alert.success('Datos ingresados con exito', {
					effect: 'genie',
					position: 'bottom-right',
					timeout:2000			
				});
				
				
			}
			
			
			
			
			this.toggleModal();
		}
		
		
		
		
		
	}
	
	
	render(){
			
			return(
				
					<div className="modal_calificaciones">
						
						<button className="btn btn-primary" onClick={this.toggleModal}><span className="glyphicon glyphicon-plus"> </span> Nuevo</button>
						
						<br/>
						<br/>
						
						
						
					<Modal isOpen={this.state.isActive} onRequestClose={this.toggleModal}  style={customStyles}>
					
						<h3>Agregar Calificaciones</h3>
						<hr/>
					
						<div className="form-group">
							<label>Tipo de calificación</label>
							<select className="form-control"
							ref={input=>{this.tipo=input}}
							>
								{this.state.tipos_calificaciones.map(this.makeItems)}
							</select>
						</div>
						<h4>Ingresa una pregunta</h4>
						<hr/>
						
						<input type="text" name="pregunta" className="form-control" 
						 autoComplete="off" placeholder="Ingresa una pregunta" 
							ref={input=>{this.pregunta=input}}
						/>

						<br/>
						<button type="button" className="btn btn-success btn-sm" onClick={this.ingresarPregunta}>Agregar pregunta</button>						
						
						<br/>
						<br/>
						{this.renderTable()}
						
						
						<hr/>
						
						<button className="btn btn-primary buttons" type="submit" onClick={this.handleSubmit}>Guardar</button>						
						<button className="btn btn-default buttons btnmargin" onClick={this.toggleModal}>Cerrar</button>
						
						
						
					</Modal>
					
					
					</div>
			
			);
	}
}

export default ModalCalificaciones;


// WEBPACK FOOTER //
// ./src/Components/Calificaciones1/ModalCalificaciones.js